import { Fragment, type ReactNode } from 'react';

import { ChevronRight } from 'lucide-react';
import { useMatches, type Params } from 'react-router-dom';

import { AuthStatus } from '@/authentication/auth-status';

import { Separator } from '../ui/separator';
import { SidebarTrigger } from '../ui/sidebar';

interface IMatches {
  id: string;
  pathname: string;
  params: Params;
  data: unknown;
  handle: unknown;
}
interface HandleType {
  crumb: (_param?: unknown) => ReactNode;
}
export const BreadCrumb = () => {
  const matches: IMatches[] = useMatches();

  const crumbs = matches
    .filter(
      (match) =>
        Boolean(match.handle) ||
        (match.id !== 'root' && !match.pathname.endsWith('/')), // Filter out root and index routes
    )
    .map((match) => {
      if (
        typeof match.handle === 'object' &&
        match.handle !== null &&
        'crumb' in match.handle
      ) {
        return (match.handle as HandleType).crumb(match.data);
      } else {
        return match.pathname.split('/').reverse()[0];
      }
    });

  return (
    <header
      aria-label="breadcrumb"
      className="px-2 sticky z-10 top-0 flex shrink-0 justify-between items-center border-b-2 border-sidebar bg-background"
    >
      <ol className="m-0 flex list-none items-center gap-2 p-3 text-base leading-none [&>li]:first-letter:capitalize [&_a]:underline">
        <SidebarTrigger />
        <Separator orientation="vertical" className="mr-2 h-4!" />
        {crumbs.map((crumb, index) =>
          crumbs.length - 1 === index ? (
            <li
              role="listitem"
              aria-current="page"
              key={index}
              className="font-bold"
            >
              {crumb}
            </li>
          ) : (
            <Fragment key={index}>
              <li role="listitem">{crumb}</li>
              <ChevronRight size={16} />
            </Fragment>
          ),
        )}
      </ol>
      <AuthStatus />
    </header>
  );
};
